import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { getUserSubscription } from 'actions/userSubscription.actions';
import { isPreviouslyPremium } from 'helpers/userHelper';

export const withUserSubscriptionInfo = Cmp => {
  const WithUserSubscriptionHoC = props => {
    const { userInfo } = props;
    const subscriptionInfoMeta = useSelector(state => state.subscriptionInfo);
    const { subscription, subscriptionLoading, subscriptionError } =
      subscriptionInfoMeta;
    const requestWillStart =
      !subscriptionLoading && !subscriptionError && !subscription;
    const dispatch = useDispatch();
    const isPreviouslyPremiumUser = isPreviouslyPremium(userInfo);

    useEffect(() => {
      if (
        !subscriptionLoading &&
        !subscriptionError &&
        !subscription &&
        isPreviouslyPremiumUser
      ) {
        dispatch(getUserSubscription());
      }
    });

    return (
      <Cmp
        {...props}
        subscriptionInfo={subscription}
        subscriptionInfoLoading={subscriptionLoading || requestWillStart}
        subscriptionInfoError={subscriptionError}
      />
    );
  };

  return WithUserSubscriptionHoC;
};
